const getGoalCopy = ({ firstName, weight, goalWeight }) => [
  `Let’s build healthy habits that last, together.`,
];

export function GoalText({ gameProfile }) {
  const copy = getGoalCopy(gameProfile?.onboardingInformation || {});
  return copy.map((c) => <div key={c}>{c}</div>);
}
